// products.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_PRODUCT_DATA,
  REMOVE_PRODUCT_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Products.
 * @module reducer/products
 */
const products = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_PRODUCT_DATA:
      return _MERGE_PRODUCT_DATA(action.payload)(state);
    case REMOVE_PRODUCT_DATA:
      return _REMOVE_PRODUCT_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge product data
 * @kind reducer/actionType
 * @name MERGE_PRODUCT_DATA
 * @param {array} {selectPath} - select path
 * @param {any} {data} - data
 * @return {Immutable.Map} New state
 */
const _MERGE_PRODUCT_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.mergeDeepIn(selectPath, data);
  };

/**
 * Remove product data
 * @kind reducer/actionType
 * @name REMOVE_PRODUCT_DATA
 * @param {array} {selectPath} - select path
 * @return {Immutable.Map} New state
 */
const _REMOVE_PRODUCT_DATA =
  ({ selectPath }) =>
  state => {
    return state.deleteIn(selectPath);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default products;
